
export default {
  OrderNo: "Order No.",
  OrderPayAmount: "Payment Amount",
  OrderPayType: "Payment Type",
  OrderPayTime: "Payment Time",
  OrderStatusSuccess: "Payment Success",
  OrderStatusFailed: "Payment Failed",
}